export { default as SortIcon } from './component';
